import { Text } from '../Text';

const Paragraph = Text.withProps(
  { variant: 'text', spaceAfter: true }, // TODO: validate variant is needed here at all
  { name: 'Paragraph' }
);

export { Paragraph };
